import React, { useEffect, useRef, useState } from "react";
import { useLocation } from 'react-router-dom';
import {useReactToPrint} from "react-to-print";
import html2pdf from 'html2pdf.js';
import moment from "moment";
import { QRCodeCanvas } from "qrcode.react";
import { ToWords } from "to-words";
import { Dialog } from "@progress/kendo-react-dialogs";
import { PostData } from "../../../../service/postData";
import { Loader } from "@progress/kendo-react-indicators";
import '../invoice.css';
import { numberFormat } from "../../../../config/numberFormat";

const LoanStatementInvoicePage = ({pdfRef, auth, isClickToGeneratePDF, isClickToPrint, transactionType, startDate, endDate}) => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const [countryInt, setCountryInt] = useState('en-IN');
    const [currency, setCurrency] = useState('INR');
    const [theme, setTheme] = useState("");
    const [companyLogo, setCompanyLogo] = useState('');
    const [brandLogo, setBrandLogo] = useState('');
    const [stateName, setStateName] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [companyAddress, setCompanyAddress] = useState('');
    const [companyPhone, setCompanyPhone] = useState('');
    const [companyEmail, setCompanyEmail] = useState('');
    const [companyGstin, setCompanyGstin] = useState('');
    const [companySignature, setCompanySignature] = useState('');
    const [invoiceTitle, setInvoiceTitle] = useState('Loan Statement');
    const [customerName, setCustomerName] = useState('');
    const [customerAddress, setCustomerAddress] = useState('');
    const [customerPhone, setCustomerPhone] = useState('');
    const [firmAdditionalField1, setFirmAdditionalField1] = useState("Firm 1");
    const [firmAdditionalField2, setFirmAdditionalField2] = useState("Firm 2");
    const [firmAdditionalFieldValue1, setFirmAdditionalFieldValue1] =
    useState("");
    const [firmAdditionalFieldValue2, setFirmAdditionalFieldValue2] =
    useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [selectedItemArray, setSelectedItemArray] = useState([]);
    const [openingBalance, setOpeningBalance] = useState(0);
    const [balanceDue, setBalanceDue] = useState(0);
    const [principalAmount, setPrincipalAmount] = useState(0);
    const [interestAmount, setInterestAmount] = useState(0);
    const [accountName, setAccountName] = useState('');
    const [accountNumber, setAccountNumber] = useState('');

    useEffect(() => {
                
        if(isClickToGeneratePDF){
            clickToGeneratePDF();
        }else if(isClickToPrint){
            handlePrint();
        }
    }, [isClickToGeneratePDF, isClickToPrint]);

    useEffect(() => {
        let _UserSession = localStorage.getItem("vs_UserSession");
        let _companySession = localStorage.getItem("vs_UserCompanySession");
        
        if (_companySession != undefined || _companySession != null) {
            _companySession = JSON.parse(_companySession);
            console.log('_companySession', JSON.stringify(_companySession));
            let _businessId = _companySession.business_id;
            let _company_id = _companySession.company_id;
            setCompanyName(_companySession.company_name);
            setCompanyAddress(_companySession.company_address);
            setCompanyPhone(_companySession.company_contact);
            setCompanyEmail(_companySession.email);
            setCompanySignature(_companySession.company_signature);
            setCurrency(_companySession.currency_code);
            setCountryInt('en-' + _companySession.country_short);

            let companyLogo = '';
            if (_companySession.company_logo.length > 6) {
                companyLogo = _companySession.company_logo;
            } else {
                companyLogo = global.LIVE_URL + "websiteFilesFolder/img/vyavsay.png";

            }
            imageToBase64(companyLogo, (base64) => {
                setCompanyLogo(base64);
            })
            getTransactionDetails(_company_id);
        }
        const brandLogo = global.webUrl + "websiteFilesFolder/img/logo.png";
        imageToBase64(brandLogo, (base64) => {
            setBrandLogo(base64);
        })

    }, []);


    const getTransactionDetails = (_company_id) => {
        if (auth) {
            setIsLoading(true);
                const requestData = JSON.stringify({          
                            loan_id: auth,
                            isDateFilter:true,
                            start_date : startDate,
                            end_date : endDate,
                        });
                
                PostData(global.userIncreaseLoanStatementList, requestData,'POST')
                .then((result) => {
                    let responseJson = result;
                    if (responseJson.success) {
                        setSelectedItemArray(responseJson.response);
                        setOpeningBalance(responseJson.opening_balance);
                        setBalanceDue(responseJson.balanceDue);
                        setPrincipalAmount(responseJson.totalPrincipal);
                        setInterestAmount(responseJson.totalInterest);
                        setAccountName(responseJson.accountName);
                        setAccountNumber(responseJson.accountNumber);

                    } else {
                        alert("Transaction details not found in system.");
                    }
                })
                .finally(() => {
                    setIsLoading(false)
                })

        }
    }


    const imageToBase64 = (imageUrl, callback) => {
        fetch(imageUrl, {
            method: "GET",
            headers: {
                'Access-Control-Allow-Origin': '*',
            },
            mode: 'cors'
        })
            .then((res) => res.blob())
            .then((blob) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    callback(reader.result);
                };
                reader.readAsDataURL(blob);
            })
            .catch((error) => {
                console.error("Error fetching image:", error);
                callback(imageUrl);
            });
    };
  

    const handlePrint = useReactToPrint({
        content: () => pdfRef.current,
        documentTitle: invoiceTitle,
        pageStyle: `
        @page { size: auto;  margin: 10mm; } 
        body { margin: 10px; }
        `,
    });

    const clickToGeneratePDF = async () => {
            setIsLoading(true);
            let _currentDate = moment(new Date()).format("yyyy-MM-dd-hh-mm-ss");
            const printArea = document.getElementById("printArea");
            // Options for the PDF layout
            const options = {
                filename: invoiceTitle + _currentDate + ".pdf", // The name of the PDF file
                margin: [10, 10, 10, 10],    // Margins for the PDF content
                x: 10,                       // x position of the content
                y: 10,                       // y position of the content
                //image: { type: "jpeg", quality: 1 },
                html2canvas: {
                    scale: 2,                 // Higher scale for better quality
                    useCORS: true,
                    logging: true,            // Disable console logging
                    dpi: 192,                  // DPI setting for canvas rendering 192
                    letterRendering: true,     // Enable letter rendering for clearer text
                },
                jsPDF: {
                    unit: 'mm',                // Units for the PDF (millimeters)
                    format: 'a4',              // Use A4 page format (you can change it to 'letter' or custom sizes)
                    orientation: 'portrait',   // Orientation of the page (portrait or landscape)
                },
                //pagebreak: { mode: ["avoid-all", "css", "legacy"] },
            };
    
            // Generate the PDF from the HTML element
            //await html2pdf().from(printArea).set(options).save();
            await html2pdf().from(printArea).set(options).toPdf().get('pdf').then(function (pdf) {
                var totalPages = pdf.internal.getNumberOfPages();
                for (var i = 1; i <= totalPages; i++) {
                    pdf.setPage(i);
                    pdf.setFontSize(10);
                }
              }).save();
            setIsLoading(false);
        }

   

    return (
        <div style={{width: '100%'}}>
            <table id="printArea" ref={pdfRef} width={'100%'}>
                <tr>
                    <td>
                        <h4 className="invoice-title" style={{ color: "var(--text-color)" }}>
                            {invoiceTitle.toUpperCase()}
                        </h4>
                        <p style={{textAlign: 'center'}}>({moment(startDate).format('DD/MM/YYY')} to {moment(endDate).format('DD/MM/YYY')})</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <table width={'100%'}>
                            <tr>
                                <td >
                                    <div
                                        id="logo"
                                        style={{
                                            flex: "1",
                                            alignItems: "center",
                                            width: "250px",
                                            height: "150px",
                                            marginTop: "10px",
                                        }}
                                        onClick={() => { }}
                                    >

                                        <img
                                            src={companyLogo}
                                            style={{
                                                maxWidth: "250px",
                                                maxHeight: "150px",
                                                borderRadius: "10px",
                                            }}
                                        />
                                    </div>
                                </td>
                                <td className="right-align" >

                                    <p className={"headerTitle "}
                                        style={{ color: "var(--text-color)" }}
                                    >
                                        {" "}
                                        Company Details<br />
                                    </p>

                                     <p >
                                            Company Name : {companyName ? companyName : 'NA'}<br />
                                        </p>
                                    <p>
                                            Company Address : {companyAddress ? companyAddress : 'NA'}<br />
                                        </p>
                                    <p

                                        >
                                            Company Phone no. : {companyPhone ? companyPhone : 'NA'}<br />
                                        </p>
                                    <p

                                        >
                                            Company Email : {companyEmail ? companyEmail : 'NA'}<br />
                                        </p>

                                    <p

                                        >
                                            {firmAdditionalField1} :{" "}
                                            {firmAdditionalFieldValue1}<br />
                                        </p>
                                    <p

                                        >
                                            {firmAdditionalField2} :{" "}
                                            {firmAdditionalFieldValue2}<br />
                                        </p>
                                </td>
                            </tr>
                        </table>
                    </td>
                </tr>
                <tr>
                    <td>
                        <div style={{margin: '10px'}}>
                            <p >
                                <b>Account Name : </b> {accountName} <br />
                            </p>
                            <p

                            >
                                <b>Account Number : </b> {accountNumber}<br /><br />
                            </p>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td>
                        <table width={'100%'} style={{ border: "var(--border)" }}>
                            <tr style={{ backgroundColor: "var(--theme-bg)", color: "var(--theme-text)" }}>
                                <th
                                        style={{
                                            textAlign: "center",
                                            fontFamily: "Arial",
                                            //lineHeight: '24px',
                                            padding: "3px",
                                        }}
                                >
                                    #
                                </th>

                                <th
                                    style={{
                                        color: "#FFFFFF",
                                        textAlign: "center",
                                        fontFamily: "Arial",
                                        //lineHeight: '24px',
                                        padding: "3px",
                                    }}
                                >
                                    Txn Type
                                </th>

                                <th
                                    style={{
                                        color: "#FFFFFF",
                                        textAlign: "center",
                                        fontFamily: "Arial",
                                        //lineHeight: '24px',
                                        padding: "3px",
                                    }}
                                >
                                    Amount
                                </th>

                                <th
                                    style={{
                                        color: "#FFFFFF",
                                        textAlign: "center",
                                        fontFamily: "Arial",
                                        //lineHeight: '24px',
                                        padding: "3px",
                                    }}
                                >
                                    Ending Balance
                                </th>
                            </tr>
                            {selectedItemArray.map((value, index) => {

                                return (
                                    <tr key={index} style={{ border: "var(--border)" }}>
                                        <td
                                            style={{
                                                fontFamily: "Arial",
                                                lineHeight: "24px",
                                                alignContent: 'flex-start',
                                                border: "var(--border)"
                                            }}
                                        >
                                            {index + 1}
                                        </td>
                                        <td
                                            style={{
                                                fontFamily: "Arial",
                                                textAlign: "center",
                                                lineHeight: "24px",
                                                border: "var(--border)"
                                            }}
                                        >
                                            <span>{value.type}</span><br />
                                        </td>

                                        <td
                                            style={{
                                                fontFamily: "Arial",
                                                textAlign: "center",
                                                color: "#333333",
                                                lineHeight: "24px",
                                                border: "var(--border)"
                                            }}
                                        >
                                            {numberFormat(value.amount)}
                                        </td>
                                        <td
                                            style={{
                                                fontFamily: "Arial",
                                                textAlign: "center",
                                                color: "#333333",
                                                lineHeight: "24px",
                                                border: "var(--border)"
                                            }}
                                        >
                                            {numberFormat(value.end_balance)}
                                        </td>    
                                    </tr>
                                );
                            })}
                        </table>
                    </td>
                </tr>
                
                
                <tr>
                    <td>
                        <table style={{ width: "100%", borderCollapse: "collapse", marginTop: '40px' }}>
                            <thead style={{ backgroundColor: "var(--theme-bg)", color: "var(--theme-text)", border: "1px solid white", textAlign: 'left', paddingLeft: '10px' }}>
                                <tr>
                                    <th style={{ width: "33.3%" }}>Loan Statement Summary</th>
                                    <th style={{ width: "33.3%" }}></th>
                                </tr>
                            </thead>

                            <tbody>
                                <tr>
                                <td style={{ width: "33.3%", border: "var(--border)" }}>
                                    <div style={{margin: '10px'}}>
                                        <p >
                                            Opening Balance : {numberFormat(openingBalance)}<br />
                                        </p>
                                        <p

                                        >
                                            Balance Due : {numberFormat(balanceDue)}<br /> <br />
                                        </p>
                                    </div>

                                </td>
                                <td style={{ width: "33.3%", border: "var(--border)" }}>
                                    <div style={{margin: '10px'}}>
                                        <p >
                                            Total Principal Paid :{numberFormat(principalAmount)} <br />
                                        </p>
                                        <p

                                        >
                                            Total Interest Paid : {numberFormat(interestAmount)}<br /><br />
                                        </p>
                                    </div>

                                </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>
                <tr><td height="40"></td></tr>
                <tr>
                    <td>
                        <div stlye={{ height: "100px !important", width: "100px !important", display: "block" }} id="logo">
                            <img src={brandLogo} alt="" title="" style={{ maxWidth: "200px" }} />
                        </div>
                    </td>
                </tr>
                
            </table>
            {
                isLoading && (
                    <Dialog >
                        <Loader type="converging-spinner" />
                    </Dialog>
                )
            }
        </div>
    )
}
export default LoanStatementInvoicePage;